import { Builder } from '@builder.io/react';
import dynamic from 'next/dynamic';
import { Icon } from '#const';
import { getIconUrl } from '#utils';

const Settlements = dynamic(() => import('./Settlements'));

export const defaultSettlementsOptions = {
	title: '<h2>We Fight for Everything You Deserve</h2>',
	subtitle: '<p><em>Millions recovered in recent settlements</em></p>',
	backgroundColor: '#274F60',
	items: [
		{ amount: '<p>$15,000,000</p>', description: '<p>Auto v. Auto Accident</p>' },
		{
			amount: '<p>$15,000,000</p>',
			description: '<p>Confidential Auto v. Pedestrian Accident</p>',
		},
		{ amount: '<p>$3,000,000</p>', description: '<p>Disputed Liability Auto Accident</p>' },
	],
} as const;

Builder.registerComponent(Settlements, {
	name: 'Settlements',
	inputs: [
		{
			name: 'title',
			friendlyName: 'Title',
			type: 'richText',
			defaultValue: defaultSettlementsOptions.title,
		},
		{
			name: 'subtitle',
			friendlyName: 'Subtitle',
			type: 'richText',
			defaultValue: defaultSettlementsOptions.subtitle,
		},
		{
			name: 'items',
			friendlyName: 'Settlements',
			type: 'list',
			defaultValue: [...defaultSettlementsOptions.items],
			subFields: [
				{
					name: 'amount',
					friendlyName: 'Amount',
					type: 'richText',
					helperText: 'e.g. $15,000,000',
				},
				{
					name: 'description',
					friendlyName: 'Description',
					type: 'richText',
				},
			],
		},
		{
			name: 'backgroundColor',
			friendlyName: 'Background Color',
			type: 'color',
			defaultValue: defaultSettlementsOptions.backgroundColor,
		},
	],
	image: getIconUrl(Icon.COLUMNS),
});
